<template>
<div class="ordinaryIndex">
        <div class="message box-shadow">
            <div v-if="!messageList.length"><i class="icon icon_notice_default overflow"></i>暂无通知</div>
            <div v-else class="message-info">
                <div class="flexstart"><i class="icon icon_notice_default overflow"></i>{{messageList[0].subject}}</div>
                <!--<div><span class="date">{{ messageList[0].datetime}}</span><span class="more cursor" v-if="messageList.length>1" @click="goToMessageMgt">更多</span></div>-->
                <div><span class="date">{{messageList[0].datetime}}</span><span class="more cursor" @click="goToMessageMgt">更多</span></div>
            </div>
        </div>
        <div class="title blod">关键数据</div>
        <div class="boxs key-data">
            <div class="box box-shadow" v-for="(item,index) in keyData" :key="index">
                <div class="summary">{{item.title}}</div>
                <div class="content">
                    <div class="num">{{item.total}}</div>
                    <i class="icon overflow" :class="[item.type?'icon_money':'icon_user']"></i>
                </div>
            </div>
        </div>
        <div class="title blod">内容数据</div>
        <div class="boxs content-data">
            <div class="box box-shadow"  v-for="(item,index) in contentData" :key="index">
                <div class="summary">{{item.title}}</div>
                <div class="content">
                    <div class="num">{{item.total}}</div>
                    <i class="icon overflow" :class="[item.cls]"></i>
                </div>
            </div>
        </div>
        <div class="trend box-shadow">
            <div class="trendTitle">
                <el-tabs v-model="activeTitleName" @tab-click="handleClick" class="trendName">
                    <el-tab-pane label="浏览趋势" name="first"></el-tab-pane>
                </el-tabs>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="今日" name="1"></el-tab-pane>
                    <el-tab-pane label="昨日" name="2"></el-tab-pane>
                    <el-tab-pane label="近7日" name="3"></el-tab-pane>
                    <el-tab-pane label="近30日" name="4"></el-tab-pane>
                    <el-tab-pane name="5">
                    <span slot="label">
                        <div class="block">
                            <el-date-picker class="dateInput" v-model="param.date" type="daterange" align="right" unlink-panels
                                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                          </div>
                    </span>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
        </div>
</div>
</template>

<script>
import LineReport from 'base/echarts/lineReport'
import {getContentData, getIndexData, getNoticeList} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'ordinaryIndex',
    data() {
        return {
            logo: require('@/common/images/index/logo.png'),
            prCodeUrl: 'http://img.capwhale.com/zjffh.jpg',//资鲸
            prCodeUrlJKT: "http://img.jingketong.cn/mp/jkt/jkt_hdt_servicecode.jpg",
            param: {
                date: [],
                status: '1' // 1今日 2昨日 3近7日 4近30天 5自定义
            },
            activeTitleName: 'first',
            activeName: 'second',
            lineDatas: {id: 'index', subText: '浏览趋势图', xdata: [], data: []},
            messageList: [],
            keyData: [],
            contentData: []
        }
    },
    created() {
        if (this.domain === 2 && this.shop.verifystatus !== 10) {
            this.$router.push({name: 'CreativeCenter'})
        }
    },
    mounted() {
        this._getContentData()
        this._getNoticeList()
    },
    methods: {
        handleClick(tab, event) {
            this.param.status = tab.name
            if (this.param.status !== '5') {
                let tmp = {
                    status: this.param.status,
                    begintime: '',
                    endtime: ''
                }
                this._getIndexData(tmp)
            }
        },
        goToMessageMgt() {
            this.$router.push({name: 'NoticeList'})
        },
        _getNoticeList() {
            getNoticeList({
                data: Object.assign({}, {page: 1, pageSize: 2}),
                success: data => {
                    this.messageList = data.data.content
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        _getContentData() {
            this.setLoading(true)
            getContentData({
                data: {},
                success: data => {
                    this.keyData = []
                    this.contentData = []
                    this.keyData.push({title: '付费用户', total: data.data.orderPayCustomer, type: 0})
                    this.keyData.push({title: '今日付款用户', total: data.data.orderpaycustomer, type: 0})
                    this.keyData.push({title: '今日新增收入', total: data.data.paymentamount, type: 1})
                    this.keyData.push({title: '可提现金额', total: data.data.validbalance, type: 1})
                    this.keyData.push({title: '账户余额', total: data.data.allbalance, type: 1})
                    this.contentData.push({title: '图文数量', total: data.data.mapNumber.article, cls: 'icon_news'})
                    this.contentData.push({title: '直播数量', total: data.data.mapNumber.livevideo, cls: 'icon_live'})
                    this.contentData.push({title: '视频数量', total: data.data.mapNumber.video, cls: 'icon_video'})
                    this.contentData.push({title: '报告数量', total: data.data.mapNumber.report, cls: 'icon_report'})
                    this.contentData.push({title: '专题数量', total: data.data.mapNumber.spackage, cls: 'icon_news'})
                    this.setLoading(false)
                    this._getIndexData(this.param)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getIndexData(tmp) {
            this.setLoading(true)
            getIndexData({
                data: tmp,
                success: data => {
                    this.lineDatas.data = []
                    this.lineDatas.xdata = data.data.xdata
                    this.lineDatas.data.push({
                        title: '访问人数',
                        color: '#1989FA',
                        list: data.data.conentviewYdata
                    })
                    this.lineDatas.data.push({
                        title: '新用户',
                        color: '#E6A23C',
                        list: data.data.newCustomerYdata
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        'param.date': {
            handler(newV, oldV) {
                let tmp = {
                    status: this.param.status,
                    begintime: newV[0],
                    endtime: newV[1]
                }
                this._getIndexData(tmp)
            }
        },
        deep: true
    },
    computed: {
        ...mapGetters([
            'user',
            'shop',
            'domain'
        ])
    },
    components: {
        LineReport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
@import "~common/scss/icon";
@import "~common/scss/mixin";
.ordinaryIndex {
        flex-grow: 1;
        .message{
            background: $tcolor-white;
            @include flexBox('');
            padding: 10px 20px;
            color: $tcolor-grey;
            font-size: $font-14;
            .icon{
                width: 16px;
                height: 16px;
                display: inline-block;
                margin-right: 5px;
            }
            .message-info{
                width: 100%;
                @include flexBox(space-between);
                .date{
                    color: $tcolor-grey;
                }
                .more{
                    color: $bgcolor-base;
                    margin-left: 10px;
                }
            }
        }
        .title{
            color: $tcolor-base;
            font-size: $font-16;
            margin: 24px 20px 14px 20px;
        }
        .boxs{
            @include flexBox(space-between);
            .box{
                background: $tcolor-white;
                padding:30px;
                flex-grow: 1;
                width: calc((100% - 40px) / 5);
                min-width: 130px;
                .summary{
                    font-size: $font-14;
                    margin-bottom: 10px;
                }
                .content{
                    @include flexBox(space-between);
                    .num{
                        font-size: $font-30;
                    }
                    .icon{
                        display: inline-block;
                    }
                }
            }
            .box~.box{
                margin-left: 10px;
            }
        }
        .key-data{
            .summary{
                color: $bgcolor-base;
            }
            .content{
                .num{
                    color: $bgcolor-orange;
                }
                .icon{
                    min-width: 34px;
                    min-height: 34px;
                    width: 34px;
                    height: 34px;
                }
            }
            .box:nth-child(1),.box:nth-child(2){
                .num{
                    color: $bgcolor-base;
                }
            }
        }
        .content-data{
            .summary{
                color: $tcolor-base;
            }
            .content{
                .num{
                    color: $tcolor-base;
                }
                .icon{
                    width: 34px;
                    height: 34px;
                }
            }
        }
        .trend{
            .trendTitle{
                margin-top: 24px;
                padding-top: 4px;
                height: 48px;
                @include flexBox(space-between);
                background: $tcolor-white;
                .trendName{
                    flex-grow: 1;
                }
                .el-tabs__nav{
                    margin-left:20px;
                    margin-right:20px;
                }
                .el-range-editor.el-input__inner{
                    padding: 3px 5px;
                }
                .el-range-editor.el-input__inner{
                    height: 32px;
                    line-height: 32px;
                }
                .el-date-editor .el-range__icon{
                    line-height: 26px;
                }
                .el-date-editor .el-range-separator{
                    line-height: 26px;
                }
            }
        }
    .lineDatas{
        background: $bgcolor-white;
        padding: 20px
    }
}
</style>
